// extracted by mini-css-extract-plugin
export var component = "more-module--component--AbxHt";
export var title = "more-module--title--tQvDk";
export var hr = "more-module--hr--3oGz8";